import axios from "./axios";

export default {
  namespaced: true,

  state: {
    devices: [],
    myDevices: [],
  },
  getters: {
    gList(state) {
      return state.devices
    },
    gAll(state) {
      return state.myDevices
    },
  },
  actions: {
    aList({ commit, dispatch, rootGetters, rootState }) {
      if (rootGetters["userauth/gLoggedIn"]) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.get('profile/sosdevices')
            .then(response => {
              dispatch("aYears", null, {root: true});
              if (response.data.data) {
                commit('SetDevices', response.data.data)
                resolve(true)
              } else {
                reject(false)
              }
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    },
    aAll({ rootGetters, dispatch, commit, rootState }) {
      if (rootGetters["userauth/gLoggedIn"]) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.get('profile/devices/' + rootGetters['user/gCurrentProfile'])
            .then(response => {
              if (response.data.data) {
                commit('SetMyDevices', response.data.data)
                resolve(true)
              } else if (response.data.message == "Unauthenticated") {
                //kill everything and move to login page
                dispatch("userauth/aAuthenticated", response.data.message, {root: true});
                reject(false)
              }
            })
        })
      }
    },
    aAdd({ commit, rootGetters, rootState }, device) {
      if (rootGetters["userauth/gLoggedIn"]) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.post('profile/devices/' + rootGetters['user/gCurrentProfile'], JSON.stringify(device))
            .then(response => {
              commit('SetNewDevice', (response.data.data))
              resolve(true)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    },
    aUpdate({ rootGetters, commit, rootState }, device,) {
      if (rootGetters["userauth/gLoggedIn"]) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.put('profile/devices/' + rootGetters['user/gCurrentProfile'] + '/' + device.id, JSON.stringify(device.visibility))
            .then(response => {
              commit('SetUpdatedDevice', response.data.data[0]);
              resolve(true);
            })
            .catch(error => {
              reject(error);
            })
        })
      }
    },
    aDelete({ rootGetters, commit, rootState }, deviceId) {
      if (rootGetters["userauth/gLoggedIn"]) {
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
          axios.delete('profile/devices/' + rootGetters['user/gCurrentProfile'] + '/' + deviceId)
            .then(response => {
              if (response.data.status) {
                commit('SetDeletedDevice', deviceId)
                resolve(true)
              }
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    },
  },
  mutations: {
    SetMyDevices(state, meds) {
      state.myDevices = meds
    },
    SetDeletedDevice(state, id) {
      state.myDevices = state.myDevices.filter(myDevices => myDevices.id !== id)
    },
    SetNewDevice(state, device) {
      state.myDevices.unshift(device[0])
      //this should be looked at later
      //state.mydevices = medis
    },
    SetDevices(state, meds) {
      state.devices = meds
    },
    SetUpdatedDevice(state, updated) {
      const index = state.myDevices.findIndex(device => device.id === updated.id);
      if (index !== -1) {
        state.myDevices.splice(index, 1, updated);
      }
    },
  }

}